import { safeObjectAssign } from "../utils/object";
import { LeadListPredictiveDialHaltReason } from "./LeadListPredictiveDialHaltReason";

/**
 * Represents a summary of lead list contact metdata.
 */
export class LeadListContactSummary {
  readonly contactCount: number = 0;

  /**
   * Number of contacts which are skipped.
   */
  readonly skippedContactCount: number = 0;

  /**
   * Number of contacts which are reserved.
   */
  readonly reservedContactCount: number = 0;

  /**
   * Number of contacts which are quarantined and unavailable for dial.
   */
  readonly quarantinedContactCount: number = 0;

  /**
   * If set, then predictive dialing is halted for this lead list.
   */
  readonly predictiveDialHaltReason?: LeadListPredictiveDialHaltReason = null;

  get handledContactCount() {
    return this.reservedContactCount + this.skippedContactCount;
  }

  constructor(deriveFrom?: Partial<LeadListContactSummary>) {
    if (deriveFrom) {
      safeObjectAssign(this, deriveFrom);
    }
  }

  /**
   * @returns Whether there is no remaining dialable contact left in this group.
   */
  get isExhausted() {
    return Boolean(this.contactCount && this.reservedContactCount + this.quarantinedContactCount + this.skippedContactCount >= this.contactCount);
  }

  get remainingContactCount() {
    return this.contactCount - this.reservedContactCount - this.quarantinedContactCount - this.skippedContactCount;
  }
}